import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class OperatorApplicationMessageTemplates {

    public static async fetchFromServer() {
        let result = await (new OperatorApiRequest({
            url: "/messageTemplate/getTemplates",
            silent: true,
            silentError: true
        })).send()
        if (result.isSuccess) {
            let templates = (result.data as OperatorApplicationApi.OperatorMessageTemplateGetTemplatesResultOpenApiModel).templates;
            OperatorAccountStore.UPDATE_MESSAGE_TEMPLATES(templates);
        }
    }
}